export default "__VITE_ASSET__BuoVQjXq__"